// extracted by mini-css-extract-plugin
export var root = "K_vW";
export var wrapper = "K_vX";
export var image = "K_vY d_w d_y d_W";
export var imageWithHeight = "K_vZ";
export var crop = "K_v0";
export var round = "K_v1";
export var fixedHeight = "K_v2";